<template>
  <div class="grid gap-x-12 lg:grid-cols-2 mt-8" v-if="modelValue">
    <section v-for="item in orderStructureItems" :key="item.key" class="mb-8">
      <h4 class="text-base mb-4 text-neutral-550">
        {{ wt('orderStructure', item.translationKey) }}
      </h4>
      <div class="boxed-button-grid">
        <input
          type="radio"
          :value="null"
          :id="item.key"
          v-model="(modelValue as any)[item.key]"
          :name="item.key"
          class="hidden" />
        <label
          v-for="option in StructureOption"
          :key="option"
          class="base-button"
          :class="{
            active: (modelValue as any)[item.key] === option,
          }"
          >{{ wt('orderStructure', 'option', option) }}
          <input type="radio" :value="option" v-model="(modelValue as any)[item.key]" :id="option" :name="item.key" />
        </label>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { StructureOption } from '@/schemas/general/enums'
import type { PropType } from 'vue'
import { useWidgetText } from '@/helpers/useWidgetText'

interface OfficeOrderStructureForm {
  competitions: StructureOption
  followUpJobsFromCompetitions: StructureOption
  generalPlanningMandates: StructureOption
  planningCommunityMandates: StructureOption
  subPlanningMandates: StructureOption
  publicClients: StructureOption
  professionalPrivates: StructureOption
}

const { wt } = useWidgetText('widget-texts-office')
const modelValue = defineModel({ type: Object as PropType<OfficeOrderStructureForm> })
const orderStructureItems = [
  {
    key: 'competitions',
    translationKey: 'competitions',
  },
  {
    key: 'followUpJobsFromCompetitions',
    translationKey: 'followUpJobsFromCompetitions',
  },
  {
    key: 'generalPlanningMandates',
    translationKey: 'generalPlanningMandates',
  },
  {
    key: 'planningCommunityMandates',
    translationKey: 'planningCommunityMandates',
  },
  {
    key: 'subPlanningMandates',
    translationKey: 'subPlanningMandates',
  },
  {
    key: 'publicClients',
    translationKey: 'publicClients',
  },
  {
    key: 'professionalPrivates',
    translationKey: 'professionalPrivates',
  },
]
</script>
